import { contactMethods } from '../data/portfolioData';

export const Contact = ({ isVisible }) => (
  <section id="contact" className={`contact ${isVisible ? 'fade-in' : ''}`}>
    <div className="contact-card">
      <div className="contact-pixels" aria-hidden="true" />
      <div className="contact-inner">
        <span className="kicker">◆ 07 · NEW GAME</span>
        <h2 className="contact-title">
          Let's build <em>something</em>.
        </h2>
        <p className="contact-sub">
          Got a mobile app that needs a steady pair of hands? I'm open to
          full-time, contract, or just a coffee chat.
        </p>
        <div className="contact-list">
          {contactMethods.map((m) => {
            if (m.href) {
              return (
                <a
                  key={m.key}
                  href={m.href}
                  className="contact-row"
                  target={m.href.startsWith('http') ? '_blank' : '_self'}
                  rel={m.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <span className="cr-k">{m.icon} {m.key}</span>
                  <span className="cr-v">{m.value}</span>
                  <span className="cr-go">↗</span>
                </a>
              );
            }
            return (
              <div key={m.key} className="contact-row static">
                <span className="cr-k">{m.icon} {m.key}</span>
                <span className="cr-v">{m.value}</span>
                <span className="cr-go">{m.meta || ''}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
